import { forwardRef } from 'react';

import { IconProps } from '@sternum/web/icons/icons.types';

export const LockIcon = forwardRef<SVGSVGElement, IconProps>(function LockIcon(
  { color = '', height = 18, width = 18, ...props },
  ref,
) {
  return (
    <svg
      ref={ref}
      width={width}
      height={height}
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.28371 4.58674C6.32034 4.47085 7.5485 4.4249 9 4.4249C10.4515 4.4249 11.6797 4.47085 12.7163 4.58674C12.5928 3.53468 12.1418 2.76482 11.5569 2.24202C10.8616 1.62056 9.93361 1.30807 9 1.30807C8.06639 1.30807 7.13836 1.62056 6.44308 2.24202C5.85819 2.76482 5.40718 3.53468 5.28371 4.58674ZM14.2412 4.84136C14.1624 3.3454 13.5596 2.15898 12.6306 1.32856C11.6384 0.441682 10.3164 0 9 0C7.68361 0 6.36164 0.441682 5.36942 1.32856C4.44037 2.15898 3.83756 3.34539 3.7588 4.84136C0.773407 5.55019 0 7.31225 0 11.2124C0 16.802 1.5885 18 9 18C16.4115 18 18 16.802 18 11.2124C18 7.31225 17.2266 5.5502 14.2412 4.84136ZM1.5 11.2124C1.5 14.0315 1.94418 15.1415 2.70189 15.7129C3.09379 16.0085 3.70633 16.266 4.75014 16.4409C5.80019 16.6169 7.17631 16.6919 9 16.6919C10.8237 16.6919 12.1998 16.6169 13.2499 16.4409C14.2937 16.266 14.9062 16.0085 15.2981 15.7129C16.0558 15.1415 16.5 14.0315 16.5 11.2124C16.5 8.39341 16.0558 7.28343 15.2981 6.71198C14.9062 6.41643 14.2937 6.15893 13.2499 5.98398C12.1998 5.80798 10.8237 5.73296 9 5.73296C7.17631 5.73296 5.80019 5.80798 4.75014 5.98398C3.70633 6.15893 3.09379 6.41643 2.70189 6.71198C1.94418 7.28343 1.5 8.39341 1.5 11.2124Z"
        fill={color || 'currentColor'}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.54223 11.9553C8.37944 11.7916 8.25 11.5329 8.25 11.2124C8.25 10.8919 8.37944 10.6333 8.54223 10.4696C8.70238 10.3086 8.8682 10.258 9 10.258C9.1318 10.258 9.29762 10.3086 9.45777 10.4696C9.62056 10.6333 9.75 10.8919 9.75 11.2124C9.75 11.5329 9.62056 11.7916 9.45777 11.9553C9.29762 12.1163 9.1318 12.1669 9 12.1669C8.8682 12.1669 8.70238 12.1163 8.54223 11.9553ZM9 13.475C7.75736 13.475 6.75 12.462 6.75 11.2124C6.75 9.96289 7.75736 8.94993 9 8.94993C10.2426 8.94993 11.25 9.96289 11.25 11.2124C11.25 12.462 10.2426 13.475 9 13.475Z"
        fill={color || 'currentColor'}
      />
    </svg>
  );
});
